const normalizeAthleteName = (value: string) =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const paraibaAthletesByCategory: Record<string, string[]> = {
  "RX Masculino": [
    "Asafe Alves",
    "Luan Vilar",
    "Pedro Albino",
    "Diego Nascimento",
    "Renato Filho",
    "Pedro Ramon",
    "Emanuel Medeiros Nóbrega",
    "Neftali Sarinho Marinho",
    "Felipe Melo",
    "Diego Varela",
    "Ricardo Alves",
    "Pedro Monteiro",
    "Lucas Alves",
    "Paulo Cirne",
    "Wendell Marcelo",
    "Tarcísio Junior",
    "Daniel Francisco",
    "Leonardo Alverga",
    "Tony",
    "Kendson Gonçalves",
    "Murilo José",
    "Fernando Jansen",
    "Gustavo Eraldo",
    "Roberto Mendes",
  ],
};

const normalizedParaibaAthletesByCategory = Object.fromEntries(
  Object.entries(paraibaAthletesByCategory).map(([category, athletes]) => [
    category,
    athletes.map(normalizeAthleteName),
  ])
);

export function isParaibaAthlete(name: string, category: string) {
  const normalizedCategoryAthletes = normalizedParaibaAthletesByCategory[category];
  if (!normalizedCategoryAthletes?.length) return false;

  const normalizedName = normalizeAthleteName(name);

  // The source list contains some abbreviated athlete names, so accept
  // exact matches and normalized contains-based matches in either direction.
  return normalizedCategoryAthletes.some(
    (athlete) =>
      athlete === normalizedName ||
      normalizedName.includes(athlete) ||
      athlete.includes(normalizedName)
  );
}
